<template>
    <img :src="image">
</template>

<script>
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'kyc-image-preview-modal',
    computed: {
        ...mapGetters(['modal']),

        image() {
            return Object.keys(this.modal.data).length
                ? this.modal.data.image
                : '';
        },
    },
};
</script>

<style lang="scss" scoped>
img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>